/* eslint-disable @typescript-eslint/dot-notation */
/* eslint-disable quote-props */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/semi */
import { ScreenOrientation } from '@awesome-cordova-plugins/screen-orientation/ngx';

import { DataService } from './data.service';
import { Component, OnInit, HostBinding } from '@angular/core';
import { Storage } from '@ionic/storage-angular';
import { TranslateService } from '@ngx-translate/core';
import { AuthenticationService } from './services/authentication.service';
import { Router } from '@angular/router';
import { Base } from './models/base';

import { environment } from '../environments/environment';
import { Platform } from '@ionic/angular';

import { StatusBar, Style } from '@capacitor/status-bar';
import { AuxService } from './services/aux.service';

import { Device } from '@capacitor/device';
import { getAppVersion } from './services/app-version';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})


export class AppComponent implements OnInit {

  @HostBinding('@.disabled')
  public animationsDisabled = false;

  onFocus$ = this.auxService.focusSubject

  navigate: any;
  versionname: string
  showversioname: boolean

  showSpinner = false

  _page = "app"
  _whoAmI = this._page + "Component"

  language = ""

  async languageInfo() {
    Base.log("[" + this._page + "] languageInfo")
    
    const info = await Device.getLanguageCode();
    this.language = info.value;

    Base.log("[" + this._page + "] languageInfo " + this.language)
    Base.log(info)
  }

  // eslint-disable-next-line max-len
  constructor(private auxService: AuxService, private platform: Platform, private screenOrientation: ScreenOrientation, public authService: AuthenticationService, public router: Router, private storage: Storage, private translate: TranslateService, private authenticationService: AuthenticationService, public dataService: DataService) {

    Base.log("[" + this._page + "] constructor ")

    this.platform.ready().then(() => {

      this.storage.create();

      this.platform.backButton.subscribeWithPriority(10, () => {
        Base.log('[' + this._page + '] Handler was called!');
      })

      Base.log("[" + this._page + "] EVALUATE LANGUAGE");
      this.languageInfo().then((lang) => {
        translate.use(this.language)
      })


      window.addEventListener('keyboardDidShow', (e) => {
        const elementFocused: any = document.querySelector(':focus');
        if (elementFocused) {
          elementFocused.blur();
          elementFocused.focus();
        }
      })

      //translate.use('de');
      /*
    this.storage.get('language').then((lang)=>{
      if (lang!==null && lang !== undefined && lang!=='') {
        translate.use(lang);
        Base.log("[" + this._page + "] language set to " + lang)
      } else {
        translate.use('de');
        Base.log("[" + this._page + "] language set DEFAULT DE ")
      }
    })
*/

      /*
          this.diagnostic.getPermissionAuthorizationStatus(this.diagnostic.permission.CAMERA)
          .then((status) => {
              switch(status){
                  case this.diagnostic.permissionStatus.GRANTED:
                      Base.log("[" + this._page + "] [" + this._page + "] Permission granted to use the camera");
                      break;
                case this.diagnostic.permissionStatus.NOT_REQUESTED:
                case this.diagnostic.permissionStatus.DENIED_ONCE:
                case this.diagnostic.permissionStatus.DENIED_ALWAYS:
                      Base.log("[" + this._page + "] Permission to use the camera has not been requested yet");
                      this.requestCamera()
                      break;
                  case this.diagnostic.permissionStatus.DENIED_ALWAYS:
                      Base.log("[" + this._page + "] Permission permanently denied to use the camera - guess we won't be using it then!");
                      break;
              }
            })
            .catch((error) => {
                Base.log("[" + this._page + "] The following error occurred: "+error);
            });


            this.diagnostic.getPermissionAuthorizationStatus(this.diagnostic.permission.ACCESS_COARSE_LOCATION)
            .then((status) => {
                switch(status){
                    case this.diagnostic.permissionStatus.GRANTED:
                        Base.log("[" + this._page + "] Permission granted to use the location");
                        break;
                    case this.diagnostic.permissionStatus.NOT_REQUESTED:
                    case this.diagnostic.permissionStatus.DENIED_ONCE:
                    case this.diagnostic.permissionStatus.DENIED_ALWAYS:
                        Base.log("[" + this._page + "] Permission to use the location has not been requested yet");
                        this.requestCoarseLocation()
                        break;
                    case this.diagnostic.permissionStatus.DENIED_ALWAYS:
                        Base.log("[" + this._page + "] Permission permanently denied to use the location - guess we won't be using it then!");
                        break;
                }
            })
            .catch((error) => {
                Base.log("[" + this._page + "] The following error occurred: "+error);
            })


            this.diagnostic.getPermissionAuthorizationStatus(this.diagnostic.permission.ACCESS_FINE_LOCATION)
            .then((status) => {
                switch(status){
                    case this.diagnostic.permissionStatus.GRANTED:
                        Base.log("[" + this._page + "] Permission granted to use the fine location");
                        break;
                    case this.diagnostic.permissionStatus.NOT_REQUESTED:
                    case this.diagnostic.permissionStatus.DENIED_ONCE:
                    case this.diagnostic.permissionStatus.DENIED_ALWAYS:
                        Base.log("[" + this._page + "] Permission to use the fine location has not been requested yet");
                        this.requestFineLocation()
                        break;
                    case this.diagnostic.permissionStatus.DENIED_ALWAYS:
                        Base.log("[" + this._page + "] Permission permanently denied to use the fine location - guess we won't be using it then!");
                        break;
                }
            })
            .catch((error) => {
                Base.log("[" + this._page + "] The following error occurred: "+error);
            })
             */
    })

  }

  /*
    requestCamera() {

      this.diagnostic.requestRuntimePermission(this.diagnostic.permission.CAMERA)
        .then((status) => {
          switch (status) {
            case this.diagnostic.permissionStatus.GRANTED:
              Base.log("[" + this._page + "] Permission granted to use the camera");
              break;
            case this.diagnostic.permissionStatus.NOT_REQUESTED:
              Base.log("[" + this._page + "] Permission to use the camera has not been requested yet");
              break;
            case this.diagnostic.permissionStatus.DENIED_ALWAYS:
              Base.log("[" + this._page + "] Permission permanently denied to use the camera - guess we won't be using it then!");
              break;
          }
        })
        .catch((error) => {
          Base.log("[" + this._page + "] The following error occurred: " + error);
        });
    }

    requestCoarseLocation() {
      this.diagnostic.requestRuntimePermission(this.diagnostic.permission.ACCESS_COARSE_LOCATION)
        .then((status) => {
          switch (status) {
            case this.diagnostic.permissionStatus.GRANTED:
              Base.log("[" + this._page + "] Permission granted to use the ACCESS_COARSE_LOCATION");
              break;
            case this.diagnostic.permissionStatus.NOT_REQUESTED:
              Base.log("[" + this._page + "] Permission to use the ACCESS_COARSE_LOCATION has not been requested yet");
              break;
            case this.diagnostic.permissionStatus.DENIED_ALWAYS:
              Base.log("[" + this._page + "] Permission permanently denied to use the ACCESS_COARSE_LOCATION - guess we won't be using it then!");
              break;
          }
        })
        .catch((error) => {
          Base.log("[" + this._page + "] The following error occurred: " + error);
        });
    }

    requestFineLocation() {
      this.diagnostic.requestRuntimePermission(this.diagnostic.permission.ACCESS_FINE_LOCATION)
        .then((status) => {
          switch (status) {
            case this.diagnostic.permissionStatus.GRANTED:
              Base.log("[" + this._page + "] Permission granted to use the ACCESS_FINE_LOCATION");
              break;
            case this.diagnostic.permissionStatus.NOT_REQUESTED:
              Base.log("[" + this._page + "] Permission to use the ACCESS_FINE_LOCATION has not been requested yet");
              break;
            case this.diagnostic.permissionStatus.DENIED_ALWAYS:
              Base.log("[" + this._page + "] Permission permanently denied to use the ACCESS_FINE_LOCATION - guess we won't be using it then!");
              break;
          }
        })
        .catch((error) => {
          Base.log("[" + this._page + "] The following error occurred: " + error);
        });
    }
  */



  storeMenuOpen() {
    //this.dataService.set("menuopen", "open")
  }


  async ngOnInit() {

    Base.log("[" + this._page + "] *************************************")
    Base.log("[" + this._page + "] *************************************")


    Base.log("[" + this._page + "] ngOnInit")

    //Base.console('info', '', this, 'constructor@App')
    getAppVersion().then((version) => {
      this.versionname = version
      Base.log("[" + this._page + "] [" + version + "]")
    })
    this.sideMenu()

    if (this.dataService.isDevice()) {

      window.addEventListener('statusTap', function () {
      });

      this.screenOrientation.lock('portrait');

      // Display content under transparent status bar (Android only)
      StatusBar.setOverlaysWebView({ overlay: true });

      const setStatusBarStyleDark = async () => {
        await StatusBar.setStyle({ style: Style.Dark });
      };

      setStatusBarStyleDark()
      //   hideStatusBar()

    }

    this.ionViewDidEnter()
  }


  async ionViewDidEnter() {
    this.showSpinner = true
    Base.log("[" + this._page + "] ionViewDidEnter ")

    this.platform.ready().then(() => {

      setTimeout(() => {
        this.storage.get('loggedin').then((result) => {
          if (result === null || result === undefined) {

            //Base.console('info', 'Start normal', this, 'v12@App')
            this.showSpinner = false
            Base.log("[" + this._page + "] Startup normal")
            this.router.navigate(['/startup'])
          } else {

            this.dataService.set("dirty", "DIRTY").then((_) => {
              Base.log("[" + this._page + "] Startup try relogin")
              this.relogin(result)
            })
          }
        })
      }, 100)
    })

  }


  login(email, password) {

    //Base.console('info', '', this, 'login1@App')
    this.authService.authenticate(email, password)
      .then(res => {
        //Base.console('info', res, this, 'login2@App navigateTo List')
        this.router.navigate(['/list'])

      }, err => {
        //Base.console('error', err, this, 'login3@App navigateTo Login')
        this.router.navigate(['/login'])
      });
  }


  restartOnboard() {
    this.dataService.set('initial', '0')
  }


  sideMenu() {

    let fleetCaption = 'Flotte'
    let deviceCaption = 'Geräte'
    let accountCaption = 'Konto'
    let cloudCaption = 'Cloud Daten'

    Device.getLanguageCode().then((info) => {

      let fleetCaption = 'Flotte'
      let deviceCaption = 'Geräte'
      let accountCaption = 'Konto'
      let cloudCaption = 'Cloud Daten'

      this.language = info.value;

      if (this.language === 'en') {
        fleetCaption = 'Fleet'
        deviceCaption = 'Devices'
        accountCaption = 'Account'
        cloudCaption = 'Cloud data'
      }


      this.navigate =
        [
          {
            title: fleetCaption,
            url: '/list',
            icon: 'car-outline'
          },
          {
            title: deviceCaption,
            url: '/devicelist',
            icon: 'hardware-chip-outline'
          },
          {
            title: accountCaption,
            url: '/user',
            icon: 'person-circle-outline'
          },
          {
            title: cloudCaption,
            url: '/cloud',
            icon: 'desktop-outline'
          },
        ]
    })


  }

  changeLang(lang) {
    this.dataService.set('language', lang).then((_) => {
      this.translate.setDefaultLang(lang)
      Base.log("[" + this._page + "] [changeLang@login] language set to " + lang)
    })
  }

  async showVersion() {
    this.showversioname = !this.showversioname
  }

  relogin(logindata) {
    Base.log("[" + this._page + "] Relogin try with " + logindata)
    if (logindata === null || logindata === undefined) {
      this.showSpinner = false
      Base.log("[" + this._page + "] Relogin not possible, going to startup")
      this.router.navigate(['/startup'])
    } else {
      this.authService.authenticate(logindata.email, logindata.password)
        .then(res => {
          this.showSpinner = false
          Base.log("[" + this._page + "] Relogin successful, going to list")
          this.router.navigate(['/list'])

        }, err => {

          //Base.console('info', 'Relogin not possible, redirect to login')
          this.showSpinner = false
          Base.log("[" + this._page + "] Relogin error, going to startup")
          Base.log(err)

          this.router.navigate(['/startup'])

        })
    }

  }

  async v12() {
    //Base.console('info', '', this, 'v12@App')

  }

  async v11() {
    //Base.console('info', '', this, 'v11@App')
    this.platform.ready().then(() => {

      this.storage.get('loggedin').then((result) => {
        //Base.console('info', 'LOGGEDIN, try relogin 1', this, 'v11@App')
        //Base.console('info', 'go to NEU-Register', this, 'v11@App navigateTo Photo')
        // continue to startup
        this.relogin(result)
      })
    })


  }

}


/*

    const setStatusBarStyleLight = async () => {
      await StatusBar.setStyle({ style: Style.Light });
    };

    const hideStatusBar = async () => {
      await StatusBar.hide();
    };

    const showStatusBar = async () => {
      await StatusBar.show();
    };

    */
